module.exports = __webpack_public_path__ + "static/media/connect-clock.447fe4c5.svg";